import React from 'react';
import { useParams } from 'react-router-dom';
import VersionHistoryTable from '../../../_shared/_components/VersionHistoryTable';

const VersionHistory: React.FC = () => {
  const { id } = useParams();
  const templateId = id ? Number(id) : 0;

  return <VersionHistoryTable templateId={templateId} />;
};

export default VersionHistory;

